import React from 'react';


export default function User({ children }) {
    return (
    <div>  
        
        {children}
    </div>  
        
       
    );
}
